import React, { useEffect, useState } from 'react';


/**
 * COMPONENTE PANTALLA GIGANTE: ¿DÓNDE QUEDÓ LA BOLITA? (Gorras)
 */
const Caps = ({ currentGameState }) => {
    const {
        phase = 'WAITING', 
        winningCapId = null,
        selectedCapId = null,
        revealData = null,
        config = {} // <-- Extraemos la config que manda el backend
    } = currentGameState || {};

    // Dinamizamos la velocidad. Por defecto 300ms
    const speedMs = config.shuffleSpeedMs || 300; 
    const speedSeconds = speedMs / 1000; // Transformamos a segundos para CSS (ej. 0.3)

    const [positions, setPositions] = useState([0, 1, 2]); 
    const [isPresenting, setIsPresenting] = useState(false);

    const ASSETS = {
        cap: '/img/games/caps/cap.png',
        prize: '/img/games/caps/bolita.png',
        logo: '/img/page/xolos-five.png'
    };

    useEffect(() => {
        let shuffleInterval;

        if (phase === 'WAITING') {
            setPositions([0, 1, 2]);
            const timer1 = setTimeout(() => setIsPresenting(true), 1000);
            const timer2 = setTimeout(() => setIsPresenting(false), 2500);
            return () => { clearTimeout(timer1); clearTimeout(timer2); };
        }

        if (phase === 'SHUFFLING') {
            setIsPresenting(false);
            shuffleInterval = setInterval(() => {
                setPositions(prev => {
                    const newPositions = [...prev];
                    for (let i = newPositions.length - 1; i > 0; i--) {
                        const j = Math.floor(Math.random() * (i + 1));
                        [newPositions[i], newPositions[j]] = [newPositions[j], newPositions[i]];
                    }
                    return newPositions;
                });
            }, speedMs); // <-- USAMOS LA VELOCIDAD MATEMÁTICA AQUÍ
        }

        return () => {
            if (shuffleInterval) clearInterval(shuffleInterval);
        };
    }, [phase, speedMs]);

    const getWrapperStyle = (capId) => {
        const currentSlotIndex = positions.indexOf(capId - 1);
        const xOffset = (currentSlotIndex - 1) * 350; 
        
        return {
            transform: `translateX(${xOffset}px)`,
            transition: phase === 'SHUFFLING' 
                ? `transform ${speedSeconds}s ease-in-out` // <-- USAMOS LOS SEGUNDOS CSS AQUÍ
                : 'transform 0.5s ease' 
        };
    };

    const getCapLiftStyle = (capId) => {
        const currentSlotIndex = positions.indexOf(capId - 1);
        const currentSlotNumber = currentSlotIndex + 1; 
        
        let yOffset = 0; 

        if (phase === 'WAITING' && isPresenting && currentSlotNumber === 2) {
            yOffset = -180;
        } else if (phase === 'REVEAL_MODAL') {
            if (currentSlotNumber === selectedCapId) yOffset = -180;
            if (selectedCapId !== winningCapId && currentSlotNumber === winningCapId) yOffset = -180;
        }

        return {
            transform: `translateY(${yOffset}px)`,
            transition: 'transform 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275)' 
        };
    };

    return (
        <div className="caps-screen">
            <img src={ASSETS.logo} alt="Logo" className="caps-screen__logo" />

            <div className="caps-screen__indicators" style={{ opacity: phase === 'SELECTING' ? 1 : 0 }}>
                <div className="caps-screen__indicator caps-screen__indicator--1">1</div>
                <div className="caps-screen__indicator caps-screen__indicator--2">2</div>
                <div className="caps-screen__indicator caps-screen__indicator--3">3</div>
            </div>

            <div className="caps-container">
                {[1, 2, 3].map((capId) => {
                    const currentSlotNumber = positions.indexOf(capId - 1) + 1;

                    return (
                        <div key={capId} className="caps-container__wrapper" style={getWrapperStyle(capId)}>
                            
                            {((phase === 'WAITING' && currentSlotNumber === 2) || (phase !== 'WAITING' && currentSlotNumber === winningCapId)) && (
                                <img src={ASSETS.prize} alt="Premio" className="caps-container__prize" />
                            )}

                            <img src={ASSETS.cap} alt={`Gorra ${capId}`} className="caps-container__cap" style={getCapLiftStyle(capId)} />
                        </div>
                    );
                })}
            </div>

            {phase === 'REVEAL_MODAL' && revealData && (
                <div className="caps-screen__modal">
                    <div className="caps-screen__modal-content" style={{ backgroundColor: revealData.isWinner ? '#198754' : '#dc3545' }}>
                        <h1 className="caps-screen__modal-title">
                            {revealData.text}
                        </h1>
                    </div>
                </div>
            )}

            <p className="caps-screen__footer">Hecho con ♥ por Five Digital Minds | 2026</p>
        </div>
    );
};

export { Caps };